var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCustomizedCarSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "30,7 25,7 25,2 23,2 23,7 18,7 18,9 23,9 23,14 25,14 25,9 30,9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7645874,16.2927246l-1.3173218-2.6345215C17.9355469,12.6357422,16.9072266,12,15.7636719,12H8.2363281 c-1.1435547,0-2.171875,0.6357422-2.6835938,1.6582031l-1.3173218,2.6345215C2.852356,17.126709,2,18.6008301,2,20.2363281 L2.0048828,26v2.2832031C2.0048828,29.2460938,2.8828125,30,4.0029297,30h1.9980469C7.1220703,30,8,29.2460938,8,28.2832031V26h8 v2.2832031C16,29.2460938,16.8789062,30,18,30h2c1.1210938,0,2-0.7539062,2-1.7167969v-8.046875 C22,18.6008301,21.147644,17.126709,19.7645874,16.2927246z M8.2363281,14h7.5273438 c0.3818359,0,0.7246094,0.2119141,0.8945312,0.5527344L17.3818359,16H6.6181641l0.7236328-1.4472656 C7.5117188,14.2119141,7.8544922,14,8.2363281,14z M6,28H4.0048828v-2H6V28z M20,28h-2v-2h2V28z M20,24H4.0048828L4,22.0146484h4 v-2H4.0285645C4.0995483,19.1809082,4.5407104,18.4345703,5.2558594,18h13.4882812 c0.7151489,0.4345703,1.1563721,1.1809082,1.227356,2.0146484H16v2h4V24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomizedCarSmall);
export default __webpack_public_path__ + "static/media/new-customized-car--small.cbe3d05cab13ffcbfa18c0c6c9e8b676.svg";
export { ForwardRef as ReactComponent };